/**
 * Enum-like constants
 */

export const CategoryType = {
  Section: 1,
  Collection: 2,
  LinkedCourseSection: 3,
  CourseCategory: 4,
  SkillPathway: 6,
  SkillPathwaySection: 7,
  SeasonSequence: 8,
} as const;

export type CategoryType = (typeof CategoryType)[keyof typeof CategoryType];

export const CourseType = {
  Simple: 0,
  Dashboard: 1,
  Redirect: 2,
} as const;

export type CourseType = (typeof CourseType)[keyof typeof CourseType];

export const LessonStatus = {
  // Retired (0) is hidden like a draft; only allowlisted draft viewers see it.
  Retired: 0,
  Draft: 1,
  Staging: 2,
  Published: 3,
} as const;

export type LessonStatus = (typeof LessonStatus)[keyof typeof LessonStatus];

export const CourseStatus = {
  // Retired (0) behaves like Draft for visibility, but is a distinct status so
  // colleagues can tell retired courses apart from drafts in the CMS.
  Retired: 0,
  Draft: 1,
  Staging: 2,
  Published: 3,
} as const;

export type CourseStatus = (typeof CourseStatus)[keyof typeof CourseStatus];

/** Persisted on courses.skill_level (nullable) */
export const CourseSkillLevel = {
  Beginner: 1,
  Intermediate: 2,
  Advanced: 3,
} as const;

export type CourseSkillLevel =
  (typeof CourseSkillLevel)[keyof typeof CourseSkillLevel];

/** Strings for pathway UI / badges — map with courseSkillLevelToLabel */
export type CourseSkillLevelLabel = "beginner" | "intermediate" | "advanced";

export const COURSE_SKILL_LEVEL_LABEL: Record<
  CourseSkillLevel,
  CourseSkillLevelLabel
> = {
  [CourseSkillLevel.Beginner]: "beginner",
  [CourseSkillLevel.Intermediate]: "intermediate",
  [CourseSkillLevel.Advanced]: "advanced",
};

export function courseSkillLevelToLabel(
  tier: CourseSkillLevel,
): CourseSkillLevelLabel {
  return COURSE_SKILL_LEVEL_LABEL[tier];
}

export function courseSkillLevelFromLabel(
  label: CourseSkillLevelLabel,
): CourseSkillLevel {
  switch (label) {
    case "beginner":
      return CourseSkillLevel.Beginner;
    case "intermediate":
      return CourseSkillLevel.Intermediate;
    case "advanced":
      return CourseSkillLevel.Advanced;
  }
}

export const COLLECTION_SLUGS = {
  LATEST: 'latest',
  CONTINUE: 'continue',
} as const;
